import {api} from './api'
import {error_handler, get_bugsnag} from './util'

let {AUTH0_CLIENT_ID: client_id, AUTH0_DOMAIN: domain} = process.env
let auth0 = null

const fake_authenticate = async () => {
  const user = {email: process.env.TEST_USER}
  sessionStorage.access_token = 'test'

  const {data: user_profile} = await api.get(`/profile?email=${user.email}`)
  sessionStorage.user = JSON.stringify({...user, ...user_profile})

  return user
}

export const login = async () => {
  try {
    await auth0.loginWithRedirect({
      redirect_uri: window.location.origin,
      appState: {hash: window.location.hash}
    })
  }
  catch (error) {
    error_handler(error)
  }
}

export const logout = async event => {
  if(event) {
    event.preventDefault()
  }

  sessionStorage.removeItem('access_token')
  sessionStorage.removeItem('user')

  return await auth0.logout({returnTo: window.location.origin})
}

export const authenticate = async () => {
  const bugsnag = get_bugsnag()

  try {
    if(process.env.TEST_USER) {
      return await fake_authenticate()
    }

    auth0 = await createAuth0Client({client_id, domain, audience: 'https://actionstation-api'})
    const q = window.location.search

    const is_authenticated = await auth0.isAuthenticated()
    const is_callback = q.includes('code=') && q.includes('state=')
    if(!is_authenticated && !is_callback) {
      return false
    }

    if(is_callback) {
      const {appState: {hash}} = await auth0.handleRedirectCallback()
      window.history.replaceState({}, document.title, '/')
      window.location.hash = hash
    }

    const user = await auth0.getUser()
    if(!sessionStorage.access_token) {
      sessionStorage.access_token = await auth0.getTokenSilently()
    }

    // TODO: this will fail if there is no stripe customer
    // at some point, members without a stripe account will also need to log in
    // so this error will need to be changed
    if(!sessionStorage.user) {
      const {data: user_profile} = await api.get(`/profile?email=${user.email}`)
      sessionStorage.user = JSON.stringify({...user, ...user_profile})
    }

    return user
  }
  catch (error) {
    console.error(error)
    bugsnag.notify(error)

    throw error
  }
}
